import { PrivacyPolicyPage } from '@/page-content/privacy-policy';
export default PrivacyPolicyPage;